module.exports = __webpack_public_path__ + "img/c03_unitspearman_Normal_ua.05872ad6.webp";